import { useAuth0 } from "../components/auth/DevAuth0Provider";
import { Navigate } from "react-router-dom";
import { Ripples } from 'ldrs/react'
import 'ldrs/react/Ripples.css'

const PrivateRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, isLoading, user } = useAuth0();

  if (isLoading) return <Ripples
    size="150"
    speed="2.5"
    color="#00aeef"
  />;

  if (!isAuthenticated) {
    // console.log("🔐 User not authenticated — redirecting to login");
    return <Navigate to="/" />;
  }

  const namespace = process.env.REACT_APP_AUTH0_NAMESPACE;

  // Try both namespace formats to handle different Auth0 configurations
  const roles = user?.[`${namespace}/roles`] || user?.[`${namespace}roles`] || [];

  const isAuthorized = allowedRoles ? roles.some(role => allowedRoles.includes(role)) : true;

  if(!isAuthorized) {
    // console.log("❌ User not authorized for this route");
    return <Navigate to='/403' />;
  }

  return isAuthenticated ? children : <Navigate to="/" />;
};

export default PrivateRoute;
